// Sections
import "./sections/header/header";
import "./sections/drawer-menu/drawer-menu";

// Snippets
import "./snippets/book-appointment/book-appointment";
import "./snippets/enquiry-form/enquiry-form";
import "./snippets/header-desktop-nav";
import "./snippets/product-images-carousel";
import "./snippets/product-groups";
import "./snippets/truncated-text";
import "./snippets/variants";
import "./snippets/drop-a-hint/drop-a-hint";
import "./snippets/wishlist";
import "./snippets/form-status";
import "./snippets//share-icons/share-icons";
import "./snippets/filter-inline-list/filter-inline-list";
import "./snippets/sort-dropdown/sort-dropdown";

